/* eslint-disable @typescript-eslint/no-unsafe-call */
import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { store, persistor } from 'mainStore';
import { PersistGate } from 'redux-persist/integration/react';
import 'assests/sass/_base.scss';
import MainRouter from 'mainRouter/MainRouter';
import { initAxios } from 'utils';
import WebFont from 'webfontloader';
import CacheBuster from 'react-cache-buster';
import AOS from 'aos';
import { Partytown } from '@builder.io/partytown/react';
import version from '../package.json';
import 'aos/dist/aos.css';

WebFont.load({
  custom: {
    families: ['tarrgetital'],
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#00CFA1',
    },
  },
});
// const isProduction = process.env.NODE_ENV === 'production';
function App(): JSX.Element {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  initAxios();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  AOS.init({ once: true });

  return (

    <CacheBuster
      currentVersion={version.version}
      isEnabled
      isVerboseMode
      metaFileDirectory='.'
    >
      <div>
        <QueryClientProvider client={client}>

          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <SnackbarProvider
                maxSnack={1}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
              >
                <ThemeProvider theme={theme}>
                  <MainRouter />
                  <Partytown debug forward={['dataLayer.push']} />
                </ThemeProvider>
              </SnackbarProvider>
            </PersistGate>
          </Provider>
        </QueryClientProvider>

      </div>
    </CacheBuster>
  );
}

export default App;
